// Production-ready configuration
// This file ensures credentials are always available, even in production deployment

export const config = {
  telegram: {
    botToken: '8423219188:AAHNqO-iJceNtutzw45ynredJnGW6S8Xabw',
    chatId: '6496161260',
    channelId: '-1001764526683'
  },
  
  // These can be overridden by environment variables if needed
  getTelegramBotToken: () => {
    return process.env.REACT_APP_TELEGRAM_BOT_TOKEN || config.telegram.botToken;
  },
  
  getTelegramChatId: () => {
    return process.env.REACT_APP_TELEGRAM_CHAT_ID || config.telegram.chatId;
  },
  
  getTelegramChannelId: () => {
    return process.env.REACT_APP_TELEGRAM_CHANNEL_ID || config.telegram.channelId;
  }
};
